import React, { useState } from 'react';
import {
  CModal,
  CModalBody,
  CModalTitle,
  CModalHeader,
  CModalFooter,
  CButton,
} from '@coreui/react';
import { convertDate } from 'src/utils/common';
import API from 'src/utils/apiCalling';
import { config } from 'src/utils/apiUrl';
import { toast } from 'react-toastify';
import { getLocalDataAsObject } from 'src/utils/CoustomStorage';
import Loader1 from 'src/views/common/loader1';


const ViewLeaveDateModal = ({
  viewLaeveModal,
  handleLeaveModal,
  leaveData,
  getLeaveForApproval,
}) => {
  const api = new API();
  const [leaveIds, setLeaveIds] = useState();
  const [reason, setReason] = useState('');
  const [isLoader1,setIsLoader1]=useState(false)
  // const [selectAll, setSelectAll] = useState(false);
  const handleLeaveIds = (e, item) => {
    let newArr = leaveIds && leaveIds.length > 0 ? [...leaveIds] : [];
    if(!e.target.checked){
      toast.warning('Please tick the checkbox')
    }else if (e.target.checked) {
      newArr.push({ id: item?.id });
      setLeaveIds(newArr);
    } else {
      let arr =
        newArr &&
        newArr.length > 0 &&
        newArr.filter(leave => leave?.id != item?.id);
      setLeaveIds(arr);
    }
  };
  const approveAndRejectLeave = async type => {
    if(!leaveIds){
      toast.warning('Please tick the checkbox')
    }else{
    setIsLoader1(true)
    if (reason) {
      let payload = {
        type: 'leave',
        is_approved: type === 'approve' ? 'approve' : 'reject',
        id: 1, //id is fixed not in used
        comment: reason,
        correction_data: JSON.stringify(leaveIds),
      };

      let result = await api.post(config.approveRejectAttendance, payload);
      if (result && result.code === 200) {
        setIsLoader1(false)
        handleLeaveModal();
        getLeaveForApproval();
        setReason('');
        setLeaveIds([]);
        toast.success(result && result?.message);
      } else {
        toast.error(result && result?.message);
      }
    } else {
      toast.warning('Please enter reason');
      setIsLoader1(false);
    }}
  };
  function allLeaveStatus(arr) {
    console.log("vewjk",arr)
    let status = '';
    let p = 0;
    let a = 0;
    let c = 0;
    let l1P = 0;
    let l2P = 0;
    let l3P = 0;
    for (let i = 0; i < arr.length; i++) {
      if(arr[i].is_cancel == 1){
        c++;
      }else if (arr[i].assign_L1 == 1 && arr[i].is_approve_L1 == 0 && arr[i].is_reject_L1 == 0) {
        l1P++;
      }else if (arr[i].assign_L2 == 1 && arr[i].is_approve_L2 == 0 && arr[i].is_reject_L2 == 0) {
        l2P++;
      }else if (arr[i].assign_L3 == 1 && arr[i].is_approve_status == 0 && arr[i].is_rejected_status == 0) {
        l3P++;
      }else if ((arr[i].assign_L1 == 1 || arr[i].assign_L2 == 1 || arr[i].assign_L3 == 1) && (arr[i].is_rejected_status == 1 || arr[i].is_reject_L1 == 1 || arr[i].is_reject_L2 == 1)) {
        a++;
      }else if ((arr[i].assign_L2 == 1 || arr[i].assign_L1 == 1 || arr[i].assign_L3 == 1) && (arr[i].is_approve_status == 0 || arr[i].is_approve_L1 == 0 || arr[i].is_approve_L2 == 0 ) && (arr[i].is_rejected_status == 0 || arr[i].is_reject_L1 == 0 || arr[i].is_reject_L2 == 0)) {
        p++;
      }else {
        a++;
      }
    }
    if (arr.length === a) {
      return (status = 'Approved');
    }else if (arr.length === c) {
      return (status = 'Cancelled');
    }else if (arr.length === l1P) {
      return (status = 'Pending L1');
    }else if (arr.length === l2P) {
      return (status = 'Pending L2');
    }else if (arr.length === l3P) {
      return (status = 'Pending L3');
    }else {
      return (status = 'Pending');
    }
  }

  let status =
    leaveData &&
    (allLeaveStatus(leaveData && leaveData?.leaveDateArray) === 'Approved' || 
    allLeaveStatus(leaveData && leaveData?.leaveDateArray) === 'Cancelled')
      ? true
      : false;
  const closeModal = () => {
    handleLeaveModal();
    setReason('');
  };
  return (
    <div>
      <CModal
        show={viewLaeveModal}
        onClose={() => closeModal()}
        size="lg"
        style={{ marginTop: '70px' }}
      >
        <CModalHeader closeButton>
          <CModalTitle>Approve and Reject Leave(s)</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {leaveData?.leaveDateArray.map((item, index) => (<>
   
          </>))}
            <div>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Leave Date</th>
                  <th scope="col">Leave Type</th>
                  <th scope="col">Leave Status</th>
                  <th scope="col">
                    {/* <input
                  type="checkbox"
                  onChange={() => setSelectAll(!selectAll)}
                ></input> */}
                  </th>
                </tr>
              </thead>
              <tbody>
                {leaveData?.leaveDateArray.map((item, index) => (<>
                  <tr key={item?.id}>
                    {console.log(item,"gf8iejfk")}
                    <th scope="row">{index + 1}</th>
                    <th>{leaveData?.employee_name}</th>
                    <td>{convertDate(item?.leave_date, 'DD-MM-YYYY')}</td>
                    <td>{item?.leave_type}</td>
                    <td>{item?.leave_status}</td>
                    <td>
                      {((item.L1_id == getLocalDataAsObject('user')[0]?.id && item.assign_L1 == 1 && item?.is_approve_L1 == 1) || (item.L2_id == getLocalDataAsObject('user')[0]?.id && item.assign_L2 == 1 && item?.is_approve_L2 == 1) || (item.assigned_to == getLocalDataAsObject('user')[0]?.id && item.assign_L3 == 1 && item?.is_approve_status == 1)) ? (
                        <i
                          className="fa fa-check"
                          style={{ color: 'green' }}
                          aria-hidden="true"
                        ></i>
                      ) : ((item.L1_id == getLocalDataAsObject('user')[0]?.id && item.assign_L1 == 1 && item?.is_reject_L1 == 1)|| (item.L2_id == getLocalDataAsObject('user')[0]?.id && item.assign_L2 == 1 && item?.is_reject_L2 == 1) || (item.assigned_to == getLocalDataAsObject('user')[0]?.id && item.assign_L3 == 1 && item?.is_rejected_status == 1) ) ? (
                        <i
                          className="fa fa-times"
                          style={{ color: 'red' }}
                          aria-hidden="true"
                        ></i>
                      ) :  ((item.L1_id == getLocalDataAsObject('user')[0]?.id && item.assign_L1 == 1 && item?.is_cancel == 1) || (item.L2_id == getLocalDataAsObject('user')[0]?.id && item.assign_L2 == 1 && item?.is_cancel == 1) || (item.assigned_to == getLocalDataAsObject('user')[0]?.id && item.assign_L3 == 1 && item?.is_cancel == 1)) ? (
                        <b
                          style={{ color: '#19789e' }}
                        >Cancelled</b>
                      ) :
                      
                      (
                        <input
                          type="checkbox"
                          onChange={e => handleLeaveIds(e, item)}
                          // checked={selectAll}
                        ></input>
                      )}
                    </td>
                  </tr>
              {(item?.assign_L2 == 1 || item?.assign_L3 == 1) && (
                    <tr>
                       <th style={{color:"#4a944d"}} colSpan={2}>L1 Manager Comment: </th>
                       <td colSpan={4}>{item?.L1_comment}</td>
                    </tr>
                  )}
                  {item?.assign_L3 == 1 && (
                    <tr>
                       <th style={{color:"#4a944d"}} colSpan={2}>L2 Manager Comment: </th>
                       <td colSpan={4}>{item?.L2_comment}</td>
                    </tr>
                  )}
              </>))}
              </tbody>
            </table>
            <form>
              <div className="form-group">
                <label for="exampleFormControlTextarea1">Comment</label>
                <textarea
                  onChange={e => setReason(e.target.value)}
                  disabled={status}
                  value={reason}
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                ></textarea>
              </div>
            </form>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            disabled={status}
            className="btn btn-primary"
            onClick={() => approveAndRejectLeave('approve')}
          >
            Approve
          </CButton>
          <CButton
            disabled={status}
            onClick={() => approveAndRejectLeave('reject')}
            className="btn btn-danger"
          >
            Reject
          </CButton>
         {isLoader1 && <Loader1></Loader1>}
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default ViewLeaveDateModal;
